import { useEffect } from 'react';

import { AutoConnectorPathingEngine } from '../../../core/connectors/AutoConnectorPathingEngine';
import type { IEventBus } from '../../../core/events/IEventBus';
import type { CommandManager } from '../../../core/commands/CommandManager';

export function useCanvasAutoConnectorPathingEngine(input: {
  eventBus: IEventBus;
  commandManager: CommandManager;
}): void {
  const { eventBus, commandManager } = input;

  // Auto connector pathing (anchor selection) after any command execution/undo/redo.
  // This keeps anchors deterministic across undo/redo without polluting history.
  useEffect(() => {
    const engine = new AutoConnectorPathingEngine(eventBus, commandManager);
    engine.start();
    return () => engine.dispose();
  }, [eventBus, commandManager]);
}
